<div class="resource-list__container">
  <div *ngFor="let resource of resourceList" class="resource-list__item">
    <tux-svg [src]="resource.svg" alt="logo" alt="logo"></tux-svg>
    <a class="resource__ext-link" [href]="resource.path" target="_blank">
      {{ resource.name }}
      <fa-icon [icon]="externalIcon" size="sm" [fixedWidth]="true"> </fa-icon>
    </a>
    <p class="resource__description">
      {{ resource.description }}
    </p>
  </div>
</div>
